import { colors } from '../../NewHire/v2/styles';
import RatingScale from './RatingScale';

interface RatingItemProps {
  title: string;
  description?: string;
  whatItLooksLike?: string[];
  value: number | undefined;
  onChange: (value: number) => void;
}

const RatingItem = ({ title, description, whatItLooksLike, value, onChange }: RatingItemProps) => {
  return (
    <div
      style={{
        background: '#fff',
        border: `1px solid ${colors.border}`,
        borderRadius: 10,
        padding: 16,
        marginBottom: 14,
      }}
    >
      <h4 style={{ margin: '0 0 6px 0', fontSize: 15, fontWeight: 700, color: colors.text }}>{title}</h4>
      {description ? (
        <p style={{ margin: '0 0 8px 0', fontSize: 13, color: colors.muted, lineHeight: 1.45 }}>{description}</p>
      ) : null}
      {whatItLooksLike?.length ? (
        <ul style={{ margin: '0 0 10px 16px', padding: 0, fontSize: 12, color: colors.muted, lineHeight: 1.5 }}>
          {whatItLooksLike.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      ) : null}
      <RatingScale value={value} onChange={onChange} />
    </div>
  );
};

export default RatingItem;
